export default "__VITE_ASSET__GHla_vLE__"